import Link from '@mui/material/Link';
import { styled } from '@mui/material/styles';

export const StyledLink = styled(Link)({
	textDecoration: 'none',
	':hover': {
		textDecoration: 'underline',
	},
});
